import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { ConfigurationService } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'

import { PhoneFieldModule } from '../phone-field'
import { SendContactEditDialogComponent } from './send-contact-edit-dialog.component'
import { SendContactEditDialogService } from './send-contact-edit-dialog.service'

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    PhoneFieldModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  providers: [
    ConfigurationService,
    SendContactEditDialogService,
  ],
  exports: [SendContactEditDialogComponent],
  declarations: [SendContactEditDialogComponent],
})
export class SendContactEditDialogModule {}
